module.exports = __webpack_public_path__ + "static/media/company.dd6fc21d.svg";